<template>
  <div class="sub-form-selection">
    <div class="sub-form-selection__columns sub-columns">
      <BaseSelect
        v-model="form.display"
        class="sub-col"
        :options="selectOptions"
        label="Display"
        name="display"
        hint="Ways of displaying options (Select list, Checkboxes, Radioboxes)."
      ></BaseSelect>

      <BaseSwitcher
        v-if="showSwitcher"
        class="sub-col"
        label="Options layout"
        v-model="form.verticalLayout"
        trueLabel="VERTICAL"
        falseLabel="HORIZONTAL"
        fillSpace
      ></BaseSwitcher>
    </div>

    <BaseTextarea
      minHeight="95"
      label="Options"
      hint="Add each option in a new line."
      :value="optionsStr"
      @input="recieveOptions"
      :isLocked="isOptionsFieldLocked"
      @click.native="onLockedFieldClick"
    ></BaseTextarea>
  </div>
</template>

<script>
  import subformMixin from '@/mixins/sub-form.mixin'
  import { MDSModalConfirmDecisionModel } from '@/models/modal-datasets.model'
  
  export default {
    mixins: [ subformMixin ],
    data () {
      return {
        isOptionsFieldLocked: false,
        optionsStr: '',
        selectOptions: Object.freeze([
          {
            value: 'select-list',
            label: 'Select list'
          },
          {
            value: 'checkboxes',
            label: 'Checkboxes'
          },
          {
            value: 'radioboxes',
            label: 'Radioboxes'
          },
        ]),
        form: {
          display: 'select-list',
          options: [
            { value: 'value_1', label: 'Option 1' },
            { value: 'value_2', label: 'Option 2' },
            { value: 'value_3', label: 'Option 3' }
          ],
          verticalLayout: true
        }
      }
    },
    computed: {
      showSwitcher () {
        return ['checkboxes', 'radioboxes'].includes(this.form.display)
      }
    },
    methods: {
      recieveOptions (val) {
        this.optionsStr = val
        
        let _options = val.split('\n')
        let _formOptions = []


        for (let item of _options) {
          if (item === '' || item === '') {
            continue
          }

          item = item.replace(' : ', ':')
          let _itemParams = item.split(':')

          if (_itemParams.length > 1) {
            _formOptions.push({ value: _itemParams[0], label: _itemParams[1] })
          } else {
            _formOptions.push({ value: _itemParams[0], label: _itemParams[0] })
          }
        }

        this.form.options = _formOptions
      },
      initialOptionsStr () {
        let _str = ''
        for (let option of this.form.options) {
         
          _str += `${option.value} : ${option.label}\n`
        }

        return _str
      },
      findIfOptionsExistsInDatabase () {
        if (this.value && this.value.options) {
          this.isOptionsFieldLocked = true
        }
      },
      unlockOptions () {
        this.isOptionsFieldLocked = false
      },
      onLockedFieldClick () {
        if (!this.isOptionsFieldLocked) return

        const props = new MDSModalConfirmDecisionModel ({
          confirmationHandler: this.unlockOptions,
          title: 'Edit select options',
          description: `Changing the <strong>options</strong> of a published field will interrupt the delivery of your content to applications that currentyly display it. Change the <strong>options</strong> only if you plan to update your client applications as well.`,
          btnTextConfirm: `Edit options`
        })
        this.$store.commit('modals/OPEN_MODAL', { name: 'ModalConfirmDecision', props })
      }
    },

    created () {
      this.findIfOptionsExistsInDatabase()
      this.optionsStr = this.initialOptionsStr()
    }
  }
</script>

<style lang="scss">
  .sub-form-selection {

    &__columns {

      .TypographyInputHint {
        width: 200%;
      }
    }

    textarea {
      resize: none;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/forms/sub-forms/SubFormSelection.vue